import { createContext } from 'react';

/** Value provided by {@link HelpProvider} and consumed via `useHelp`. */
export interface HelpContextValue {
  /** Slug of the article currently open in the HelpDrawer, or null. */
  openSlug: string | null;
  /** Open the HelpDrawer showing the article with the given slug. */
  openArticle: (slug: string) => void;
  /** Close the HelpDrawer. */
  close: () => void;
}

/**
 * Contextual-help context.
 *
 * The default is a no-op so components such as {@link HelpTip} remain usable (and
 * unit-testable) without a surrounding provider; a real {@link HelpProvider}
 * supplies the drawer behaviour in the running app.
 */
export const HelpContext = createContext<HelpContextValue>({
  openSlug: null,
  openArticle: () => undefined,
  close: () => undefined,
});
